// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__S33WS","link":"styles_link__SmOww","center":"styles_center__4sNYZ","qrCodeButton":"styles_qrCodeButton__-Qk88"};